/**
 * Why the server refused to stop or cancel a session that exists locally.
 *
 * Both refusals mean the local copy is not on the server, so it is cleared
 * and never retried:
 * - `expired` — 400 `no_active_session`: never started, cancelled, or stopped
 *   long enough ago that the server let it go.
 * - `elsewhere` — 403 `other_workout_active`: the user's live session is for
 *   another workout.
 *
 * Branches on the code first, then on `meta.reason` (stamped on
 * `details.reason`); never on the message.
 */

import { API_ERROR_CODES, ApiErrorClass } from '../../../types/api/errors';

export type SessionRefusal = 'expired' | 'elsewhere';

export const sessionRefusal = (error: unknown): SessionRefusal | null => {
  if (!(error instanceof ApiErrorClass)) return null;
  const reason = error.details?.reason;
  if (
    error.code === API_ERROR_CODES.BAD_REQUEST &&
    reason === 'no_active_session'
  ) {
    return 'expired';
  }
  if (
    error.code === API_ERROR_CODES.FORBIDDEN &&
    reason === 'other_workout_active'
  ) {
    return 'elsewhere';
  }
  return null;
};
